import styled from 'styled-components';
import { colors } from 'Constants/Colors';
import { radioClasses, formControlLabelClasses } from '@mui/material';

export const ContainerPublish = styled.div`
  display: flex;
  flex-direction: column;
  font-family: metropolis;
  font-weight: bold;
  font-size: 1.25rem;
  width: 60%;
  margin: 2% auto;
`;
export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 30vh;
  background: ${colors.WHITE};
  border-radius: 1rem;
  padding: 3rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const radioButton = {
  [`& .${formControlLabelClasses.label}`]: {
    fontWeight: 'bold',
  },
  [`& .${radioClasses.root}`]: {
    color: colors.BLACK,
  },
  [`& .${radioClasses.checked}`]: {
    color: `${colors.GREEN} !important`,
  },
};

export const CustomMsg = styled.p`
  margin-left: 2rem;
  font-weight: normal;
  font-size: 1rem;
  color: ${colors.GRAY_DARK};
`;

export const WarningMessage = styled.div`
  margin: 2rem 0;
`;
